const SerialCustomObject = {
  path: "",
  name: "",
  redirect: "serial-custom-object",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "serial-custom-object",
      name: "Serial Custom Object",
      redirect: "serial-custom-object",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,

        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductSerialCustomObject"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: ":id",
          name: "Serial Custom Object Detail",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductSerialCustomObject/detail"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
      ],
    },
  ],
};
const productCustomObject = {
  path: "",
  name: "",
  redirect: "product-custom-object",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "product-custom-object",
      name: "Product Custom Object",
      redirect: "product-custom-object",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,

        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductCustomObject"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: ":id",
          name: "Product Custom Object Detail",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductCustomObject/detail"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
      ],
    },
  ],
};
const GroupBarcode = {
  path: "",
  name: "",
  redirect: "group-barcode",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "group-barcode",
      name: "Group Barcode",
      redirect: "group-barcode",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,

        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/GroupBarcode"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: ":id",
          name: "Group Barcode Detail",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/GroupBarcode/detail"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
      ],
    },
  ],
};
const ProductBrand = {
  path: "",
  name: "",
  redirect: "product-brand",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "product-brand",
      name: "Product Brand",
      redirect: "product-brand",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,

        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductBrand"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: ":id",
          name: "Product Brand Detail",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductBrand/detail"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
      ],
    },
  ],
};
const ProductModel = {
  path: "",
  name: "",
  redirect: "product-model",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "product-model",
      name: "Product Model",
      redirect: "product-model",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,

        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductModel"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: ":id",
          name: "Product Model Detail",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductModel/detail"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
      ],
    },
  ],
};
const ProductSubModel = {
  path: "",
  name: "",
  redirect: "product-sub-model",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "product-sub-model",
      name: "Product Sub Model",
      redirect: "product-sub-model",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,

        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductSubModel"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: ":id",
          name: "Product Sub Model Detail",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductSubModel/detail"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
      ],
    },
  ],
};
const SaleStatus = {
  path: "",
  name: "",
  redirect: "sale-status",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "sale-status",
      name: "Sale Status",
      redirect: "sale-status",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,

        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/SaleStatus"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: ":id",
          name: "Sale Status Detail",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/SaleStatus/detail"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
      ],
    },
  ],
};
const ProductMounting = {
  path: "",
  name: "",
  redirect: "product-serial-mounting",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "product-serial-mounting",
      name: "Product Serial Mounting",
      redirect: "product-serial-mounting",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,

        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductMounting"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },

        {
          path: ":id",
          name: "Product Serial Mounting Detail",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductMounting/detail"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
      ],
    },
  ],
};

export const ProductSetting = {
  path: "",
  name: "",
  redirect: "product-setting",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "product-setting",
      name: "Product Setting",
      redirect: "product-setting",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,
        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import("@/views/pages/setting/settingPage/ProductSetting"),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: "serial-custom-fields",
          name: "Product Serial Custom Fields",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductSerialCustomField"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: "custom-field",
          name: "Product Custom Field",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductCustomField"
            ),
          meta: {
            requiresAuth: true,

            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: "product-formula-setting",
          name: "Product Formula Setting",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductFormula"
            ),
          meta: {
            requiresAuth: true,

            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        productCustomObject,
        SerialCustomObject,
        GroupBarcode,
        ProductBrand,
        ProductModel,
        ProductSubModel,
        SaleStatus,
        ProductMounting,
        {
          path: "product-mounting-setting",
          name: "Product Serial Mounting Setting",
          component: () =>
            import(
              "@/views/pages/setting/settingPage/ProductSetting/ProductMounting/setting"
            ),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
      ],
    },
  ],
};
